import { useQuery } from '@tanstack/react-query';
import { useApi } from './useApi';

export const useProviderEmails = () => {
  const api = useApi();
  return useQuery<{ email: string }[]>(['provider-emails'], () =>
    api.getProviderEmails(),
  );
};
